
<div id="tree-map" :class="{ active_tree_map: ready, loader_tree_map: !ready}" v-if="show && show_inner">
    <template v-if="!ready">
            <Loader class="half_opacity"/>
    </template>
    <template v-if="ready">
        <GChart
            :settings="{packages: ['corechart','table','treemap']}"
            :data="treeData"
            :options="chartOptions"
            :events="chartEvents"
            :class="{ ready: ready_map, loading: !ready_map}"
            type="TreeMap"
            id="tree_map_chart"
            ref="gChart"
            />
    </template>
</div>
